import { EmailAttachmentConfig } from "./email-attachment-config";
import { PeppolInvoiceResponseConfig } from "./ubl-dossier-invoice-response-config";

export enum IncludePdfsInArchiveMode {
	NO_PDFS_IN_ARCHIVE = 0,
	ONLY_MAIN_PDF = 1,
	ALL_PDFS = 2,
}

export class UblDossierConfig {
	CostCenter:string = "";
	IncludeSalePdf:boolean = false;
	AccountingCost:string = "";
	UblType:string = "";
	UseLedgerAccountAsInvoiceLineName:boolean = false;
	IncludeSaleSeperatelyInZip:boolean = false;
	IncludePurchasePdfsInXml:IncludePdfsInArchiveMode = IncludePdfsInArchiveMode.NO_PDFS_IN_ARCHIVE;
	IncludePurchasePdfsInZip:IncludePdfsInArchiveMode = IncludePdfsInArchiveMode.NO_PDFS_IN_ARCHIVE;
	FilterPurchasesOnVatPeriod:boolean = false;
	BookkeeperEmail:string = "";
	BookkeeperEmailPurchases:string = "";
	BookkeeperEmailArchives:string = "";
	BookkeeperEmailConfigs: { [key: string]: EmailAttachmentConfig } = {};
	PeppolBookkeeperEmail:string = "";
	PeppolBookkeeperEmailPurchases:string = "";
	PeppolSendCopyToBookkeeper:boolean = false;
	LeeggoedLedger:string = "418000";
	ClearFactsCompatibiltiy:boolean = false;
	IncludeClientsXml:boolean = false;
	DontIncludePdfInPeppolUbl:boolean = false;
	PeppolSendEnabledByDefault:boolean = false;
	UseInvoiceNumberAsPaymentReference:boolean = false;
	PeppolLayoutID:number = 0;
	IncludeBarCode:boolean = false;

	PeppolNoteField:string = "";
	PeppolPoField:string = "";
	PeppolDeliveryField:string = "";
	PeppolGlnEV:string = "";
	PeppolIban:string = ""
	PeppolBic:string = ""
	NormalizePeppolUblPrefixes:boolean = false;
	DefaultPaymentMeansCode:string = "";
	PeppolInvoiceResponseSettings:PeppolInvoiceResponseConfig = new PeppolInvoiceResponseConfig();

	// eslint-disable-next-line max-lines-per-function
	public constructor(data?:any){
		if (!data) return;
		this.CostCenter = data.CostCenter;
		this.IncludeSalePdf = data.IncludeSalePdf;
		this.AccountingCost = data.AccountingCost;
		this.UblType = data.UblType || "invoice";
		this.UseLedgerAccountAsInvoiceLineName = data.UseLedgerAccountAsInvoiceLineName;
		this.FilterPurchasesOnVatPeriod = data.FilterPurchasesOnVatPeriod;
		this.IncludeSaleSeperatelyInZip = data.IncludeSaleSeperatelyInZip;
		this.IncludePurchasePdfsInXml = data.IncludePurchasePdfsInXml || IncludePdfsInArchiveMode.NO_PDFS_IN_ARCHIVE;
		this.IncludePurchasePdfsInZip = data.IncludePurchasePdfsInZip || IncludePdfsInArchiveMode.NO_PDFS_IN_ARCHIVE;
		this.BookkeeperEmail = data.BookkeeperEmail;
		this.BookkeeperEmailPurchases = data.BookkeeperEmailPurchases;
		this.PeppolBookkeeperEmail = data.PeppolBookkeeperEmail;
		this.PeppolBookkeeperEmailPurchases = data.PeppolBookkeeperEmailPurchases;
		this.BookkeeperEmailArchives = data.BookkeeperEmailArchives;

		// Parse BookkeeperEmailConfigs
		if (data.BookkeeperEmailConfigs) {
			this.BookkeeperEmailConfigs = {};
			for (const key in data.BookkeeperEmailConfigs) {
				this.BookkeeperEmailConfigs[key] = new EmailAttachmentConfig(data.BookkeeperEmailConfigs[key]);
			}
		}

		this.PeppolSendCopyToBookkeeper = data.PeppolSendCopyToBookkeeper;
		this.LeeggoedLedger = data.LeeggoedLedger || "418000";
		this.ClearFactsCompatibiltiy = data.ClearFactsCompatibiltiy;
		this.IncludeClientsXml = data.IncludeClientsXml;
		this.DontIncludePdfInPeppolUbl = data.DontIncludePdfInPeppolUbl;
		this.PeppolSendEnabledByDefault = data.PeppolSendEnabledByDefault;
		this.UseInvoiceNumberAsPaymentReference = data.UseInvoiceNumberAsPaymentReference;
		this.PeppolLayoutID = data.PeppolLayoutID || 0;
		this.IncludeBarCode = data.IncludeBarCode;
		this.PeppolNoteField = data.PeppolNoteField || "";
		this.PeppolPoField = data.PeppolPoField || "";
		this.PeppolDeliveryField = data.PeppolDeliveryField || "";
		this.PeppolGlnEV = data.PeppolGlnEV;
		this.PeppolIban = data.PeppolIban;
		this.PeppolBic = data.PeppolBic;
		this.NormalizePeppolUblPrefixes = data.NormalizePeppolUblPrefixes;
		this.DefaultPaymentMeansCode = data.DefaultPaymentMeansCode || "";
		this.PeppolInvoiceResponseSettings = new PeppolInvoiceResponseConfig(data.PeppolInvoiceResponseSettings);
	}

	// eslint-disable-next-line max-lines-per-function
	public getJSON(){
		const bookkeeperEmailConfigs: { [key: string]: any } = {};
		for (const key in this.BookkeeperEmailConfigs) {
			bookkeeperEmailConfigs[key] = this.BookkeeperEmailConfigs[key].getJSON();
		}

		return {
			CostCenter: this.CostCenter,
			IncludeSalePdf: this.IncludeSalePdf,
			AccountingCost: this.AccountingCost,
			UblType: this.UblType,
			UseLedgerAccountAsInvoiceLineName: this.UseLedgerAccountAsInvoiceLineName,
			FilterPurchasesOnVatPeriod: this.FilterPurchasesOnVatPeriod,
			IncludeSaleSeperatelyInZip: this.IncludeSaleSeperatelyInZip,
			IncludePurchasePdfsInXml: this.IncludePurchasePdfsInXml,
			IncludePurchasePdfsInZip: this.IncludePurchasePdfsInZip,
			BookkeeperEmail: this.BookkeeperEmail,
			BookkeeperEmailPurchases: this.BookkeeperEmailPurchases,
			BookkeeperEmailArchives: this.BookkeeperEmailArchives,
			BookkeeperEmailConfigs: bookkeeperEmailConfigs,
			PeppolBookkeeperEmail: this.PeppolBookkeeperEmail,
			PeppolBookkeeperEmailPurchases: this.PeppolBookkeeperEmailPurchases,
			PeppolSendCopyToBookkeeper: this.PeppolSendCopyToBookkeeper,
			LeeggoedLedger: this.LeeggoedLedger,
			ClearFactsCompatibiltiy: this.ClearFactsCompatibiltiy,
			IncludeClientsXml: this.IncludeClientsXml,
			DontIncludePdfInPeppolUbl: this.DontIncludePdfInPeppolUbl,
			PeppolSendEnabledByDefault: this.PeppolSendEnabledByDefault,
			UseInvoiceNumberAsPaymentReference: this.UseInvoiceNumberAsPaymentReference,
			PeppolLayoutID: this.PeppolLayoutID,
			IncludeBarCode: this.IncludeBarCode,
			PeppolNoteField: this.PeppolNoteField,
			PeppolPoField: this.PeppolPoField,
			PeppolDeliveryField: this.PeppolDeliveryField,
			PeppolGlnEV: this.PeppolGlnEV,
			PeppolIban: this.PeppolIban.trim(),
			PeppolBic: this.PeppolBic.trim(),
			NormalizePeppolUblPrefixes: this.NormalizePeppolUblPrefixes,
			DefaultPaymentMeansCode: this.DefaultPaymentMeansCode,
			PeppolInvoiceResponseConfig: this.PeppolInvoiceResponseSettings.getJSON()
		};
	}

	isPeppolConfigured():boolean {
		return this.PeppolIban != "" && this.PeppolBic != "";
	}
}
